const eventNavBar = (parent, child) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `header_navigation_bar_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on ${child ? child.toLowerCase() : parent.toLowerCase()}`,
    eventLabel: `${parent.toLowerCase()}`,
  });
};
export default eventNavBar;
